import { render, staticRenderFns } from "./leftBox.vue?vue&type=template&id=2ee596b0"
import script from "./leftBox.vue?vue&type=script&lang=js"
export * from "./leftBox.vue?vue&type=script&lang=js"
import style0 from "./leftBox.vue?vue&type=style&index=0&id=2ee596b0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports